var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('settings',{attrs:{"personalData":_vm.personal_data,"personName":_vm.personName,"personUrl":_vm.personUrl,"personEye":_vm.personEye,"userUuid":_vm.userUuid},on:{"personDataUpdated":_vm.loadMyUser}})}
var staticRenderFns = []

export { render, staticRenderFns }